var map = {
	"./en/form.json": 80410,
	"./en/measurement.json": 57817,
	"./es/form.json": 72872,
	"./es/measurement.json": 97943,
	"./zh-Hans/form.json": 74941,
	"./zh-Hans/measurement.json": 31892,
	"./zh-Hant/form.json": 24618,
	"./zh-Hant/measurement.json": 36088
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59252;